<template>
    <footer class="footer" ref="footer">
        <div class="inner">
            <h1 class="logo">
                <a href="">
                    <img src="@/assets/resource/icon/footer-logo.svg" alt=""  v-if="$store.state.hospStore.hostNm === '대동맥혈관병원'">
                    <img src="@/assets/resource/icon/footer-logo--brain.svg" alt=""  v-if="$store.state.hospStore.hostNm === '뇌혈관병원'">
                    <img src="@/assets/resource/icon/footer-logo--mom.svg" alt=""  v-if="$store.state.hospStore.hostNm === '엄마아기병원'">
                    <img src="@/assets/resource/icon/footer-logo--blood.png" alt=""  v-if="$store.state.hospStore.hostNm === '혈액암병원'">
                </a>
            </h1>
            <div class="footer-con">
                <ul class="footer-con__menu">
                    <li class="footer-con__menu--list">
                        <a href="https://seoul.eumc.ac.kr/medical/payment1.do" title="새 창 열림" target="_blank" v-if="$store.getters.getHost != 'H0009'">비급여진료비</a>
                        <a href="https://mokdong.eumc.ac.kr/medical/payment1.do" title="새 창 열림" target="_blank" v-else>비급여진료비</a>
                    </li>
                    <li class="footer-con__menu--list">
                        <a href="" @click.prevent="$refs.terms.popupBtn">이용약관</a>
                    </li>
                    <li class="footer-con__menu--list">
                        <a href="" @click.prevent="$refs.right.popupBtn">환자의 권리와 의무</a>
                    </li>
                    <li class="footer-con__menu--list">
                        <router-link to="/kr/etc/privacy" class="font-main">개인정보처리방침</router-link>
                    </li>
                    <li class="footer-con__menu--list">
                        <router-link to="/kr/etc/name">가명정보처리방침</router-link>
                    </li>
                </ul>
                <div class="footer-con__info"  v-if="$store.state.hospStore.hostNm === '혈액암병원'">
                    <p>
                        주소 : (07985)서울특별시 양천구 안양천로 1071 <br>
                        대표번호 : 1666-5000 <br>
                        <br>
                        Copyright (c) Ewha Womans University Medical Center. All rights reserved.
                    </p>
                </div>
                <div class="footer-con__info"  v-else>
                    <p>
                        주소 : (07804)서울특별시 강서구 공항대로 260 <br>
                        대표번호 : 1522-7000 <br>
                        <br>
                        Copyright (c) Ewha Womans University Medical Center. All rights reserved.
                    </p>
                </div>
            </div>
            <div class="footer-link">
                <div class="footer-select" ref="footerSelect1">
                    <a href="javascript:;" class="footer-select--btn" @click.prevent="footer_select1" :class="{ active: footer_option1 }">연구/교육기관</a>
                    <slide-up-down :active="footer_option1" class="footer-option">
                        <template v-if="$store.getters.getHost != 'H0009'">
                            <a href="http://part.eumc.ac.kr/dept/RDPC/index.do" class="footer-option--btn" target="_blank" title="새 창 열림">연구진흥단/첨단의생명연구원</a>
                            <a href="https://seoul.eumc.ac.kr/ctc/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">이대서울병원 임상시험센터</a>
                            <a href="http://part.eumc.ac.kr/dept/inform/index.do" class="footer-option--btn" target="_blank" title="새 창 열림">이화의료데이터사업단</a>
                            <a href="http://part.eumc.ac.kr/dept/hrpp/index.do" class="footer-option--btn" target="_blank" title="새 창 열림">연구대상자보호센터</a>
                            <a href="http://part.eumc.ac.kr/dept/hubig/index.do" class="footer-option--btn" target="_blank" title="새 창 열림">이화의료아카데미</a>
                        </template>
                        <template v-else>
                            <a href="http://part.eumc.ac.kr/dept/RDPC/index.do" class="footer-option--btn" target="_blank" title="새 창 열림">첨단의생명연구원</a>
                            <a href="https://mokdong.eumc.ac.kr/convergence/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">융합의학연구원</a>
                            <a href="http://part.eumc.ac.kr/dept/erbiocore/index.do" class="footer-option--btn" target="_blank" title="새 창 열림">ER 바이오코어 사업단</a>
                            <a href="https://mokdong.eumc.ac.kr/convergence/support/laboratory/introduction.do" class="footer-option--btn" target="_blank" title="새 창 열림">동물실험실</a>
                            <a href="https://mokdong.eumc.ac.kr/ctc/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">이대목동병원 임상시험센터</a>
                            <a href="http://part.eumc.ac.kr/dept/inform/index.do" class="footer-option--btn" target="_blank" title="새 창 열림">이화의료데이터사업단</a>
                            <a href="http://part.eumc.ac.kr/dept/hrpp/index.do" class="footer-option--btn" target="_blank" title="새 창 열림">연구대상자보호센터</a>
                        </template>
                    </slide-up-down>
                </div>
                <div class="footer-select" ref="footerSelect2">
                    <a href="javascript:;" class="footer-select--btn" @click.prevent="footer_select2" :class="{ active: footer_option2 }">패밀리사이트</a>
                    <slide-up-down :active="footer_option2" class="footer-option">
                        <a href="https://www.eumc.ac.kr/" class="footer-option--btn" target="_blank" title="새 창 열림">이화여자대학교 의료원</a>
                        <a href="https://www.eumc.ac.kr/fund/" class="footer-option--btn" target="_blank" title="새 창 열림">이화여자대학교 의료원 발전기금</a>
                        <a v-if="$store.getters.getHost == 'H0009'" href="https://mokdong.eumc.ac.kr/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">이대목동병원</a>
                        <a href="https://seoul.eumc.ac.kr/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">이대서울병원</a>
                        <a v-if="$store.getters.getHost != 'H0009'" href="https://mokdong.eumc.ac.kr/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">이대목동병원</a>
                        <a v-if="$store.getters.getHost == 'H0009'" href="http://ewhabrain.eumc.ac.kr" class="footer-option--btn" target="_blank" title="새 창 열림">이대뇌혈관병원</a>
                        <a v-if="$store.state.hospStore.hostNm !== '뇌혈관병원' && $store.getters.getHost != 'H0009'" href="http://ewhabrain.eumc.ac.kr" class="footer-option--btn" target="_blank" title="새 창 열림">이대뇌혈관병원</a>
                        <a v-if="$store.state.hospStore.hostNm !== '대동맥혈관병원'" href="http://aorta.eumc.ac.kr" class="footer-option--btn" target="_blank" title="새 창 열림">이대대동맥혈관병원</a>
                        <a v-if="$store.state.hospStore.hostNm !== '엄마아기병원'" href="http://mombaby.eumc.ac.kr" class="footer-option--btn" target="_blank" title="새 창 열림">이대엄마아기병원</a>
                        
                        <a href="https://wch.eumc.ac.kr/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">이대여성암병원</a>
                        <a href="https://ewui.eumc.ac.kr/main.do" class="footer-option--btn" target="_blank" title="새 창 열림">이대비뇨기병원</a>
                        <a v-if="$store.state.hospStore.hostNm !== '혈액암병원'" href="https://blood.eumc.ac.kr/" class="footer-option--btn" target="_blank" title="새 창 열림">이대혈액암병원</a>
                        

                        <a href="https://part.eumc.ac.kr/dept/pogoonyogoan/index.do" class="footer-option--btn" target="_blank" title="새 창 열림">보구녀관</a>
                        <a href="http://www.ewha.ac.kr/mbs/ewhakr/index.jsp" class="footer-option--btn" target="_blank" title="새 창 열림">이화여자대학교</a>
                        <a href="http://www.ewhamed.ac.kr/" class="footer-option--btn" target="_blank" title="새 창 열림">이화여자대학교 의과대학</a>
                        <a href="http://nursing.ewha.ac.kr/" class="footer-option--btn" target="_blank" title="새 창 열림">이화여자대학교 간호대학</a>
                    </slide-up-down>
                </div>
            </div>
        </div>
    </footer>
    <kr_popup_terms ref="terms"/>
    <kr_popup_patientRight ref="right"/>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
    components: {
        SlideUpDown,
    },
    data() {
        return {
            footer_option1: false,
            footer_option2: false,
        };
    },
    methods: {
        footer_select1() {
            this.footer_option1 = !this.footer_option1;
        },
        footer_select2() {
            this.footer_option2 = !this.footer_option2;
        },
        closeFooterOptions(event) {
            // if(!this.$el.querySelector) return
            const footerSelect1 = this.$refs.footerSelect1;
            const footerSelect2 = this.$refs.footerSelect2;
            if (
                footerSelect1 && !footerSelect1.contains(event.target) &&
                footerSelect2 && !footerSelect2.contains(event.target)
            ) {
                this.footer_option1 = false;
                this.footer_option2 = false;
            }
        },
    },
    mounted() {
        document.addEventListener('click', this.closeFooterOptions);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.closeFooterOptions);
    },
};
</script>
